import React from "react";
import PropTypes from "prop-types";
import styles from "./SpeakerNameForm.module.css";

const noop = () => {};

export function SpeakerNameForm({
  name,
  onChange,
  embedded,
  imageType,
  individualFirstName,
  individualLastName,
  onIndividualFirstNameChange,
  onIndividualLastNameChange,
  coupleFirstNames,
  coupleLastName,
  onCoupleFirstNamesChange,
  onCoupleLastNameChange,
  speakerAFirstName,
  speakerALastName,
  speakerBFirstName,
  speakerBLastName,
  onSpeakerAFirstNameChange,
  onSpeakerALastNameChange,
  onSpeakerBFirstNameChange,
  onSpeakerBLastNameChange,
}) {
  const isCouple = imageType === "couple";

  return (
    <section className={`${styles.card} ${embedded ? styles.embedded : ""}`}>
      <div className={styles.headerWrap}>
        <h3 className={styles.title}>Speaker Name</h3>
      </div>

      <div className={styles.divider} />

      {!isCouple && (
        <div className={styles.fieldRow}>
          <div className={styles.pairRow}>
            <label className={styles.srOnly} htmlFor="speakerFirstName">
              Speaker First Name
            </label>
            <input
              id="speakerFirstName"
              name="speakerFirstName"
              type="text"
              value={individualFirstName}
              placeholder="First"
              className={styles.input}
              onChange={(e) => onIndividualFirstNameChange(e.target.value)}
            />

            <label className={styles.srOnly} htmlFor="speakerLastName">
              Speaker Last Name
            </label>
            <input
              id="speakerLastName"
              name="speakerLastName"
              type="text"
              value={individualLastName}
              placeholder="Last"
              className={styles.input}
              onChange={(e) => onIndividualLastNameChange(e.target.value)}
            />
          </div>
        </div>
      )}

      {isCouple && (
        <>
          <div className={styles.sectionBlock}>
            <p className={styles.sectionLabel}>Couple</p>

            <div className={styles.fieldRowCompact}>
              <label className={styles.srOnly} htmlFor="speakerName">
                Speaker Name
              </label>
              <input
                id="speakerName"
                name="speakerName"
                type="text"
                value={name}
                placeholder="First & First Last (First Last & First Last)"
                className={styles.input}
                onChange={(e) => onChange(e.target.value)}
              />
            </div>

            <div className={styles.pairRow}>
              <label className={styles.srOnly} htmlFor="coupleFirstNames">
                Couple First Names
              </label>
              <input
                id="coupleFirstNames"
                name="coupleFirstNames"
                type="text"
                value={coupleFirstNames}
                placeholder="First & First"
                className={styles.input}
                onChange={(e) => onCoupleFirstNamesChange(e.target.value)}
              />

              <label className={styles.srOnly} htmlFor="coupleLastName">
                Couple Last Name
              </label>
              <input
                id="coupleLastName"
                name="coupleLastName"
                type="text"
                value={coupleLastName}
                placeholder="Last (Last / Last)"
                className={styles.input}
                onChange={(e) => onCoupleLastNameChange(e.target.value)}
              />
            </div>
          </div>

          <div className={styles.coupleRow}>
            <div className={styles.coupleCol}>
              <label className={styles.label} htmlFor="speakerAFirstName">
                Speaker A
              </label>
              <input
                id="speakerAFirstName"
                name="speakerAFirstName"
                type="text"
                value={speakerAFirstName}
                placeholder="First"
                className={styles.input}
                onChange={(e) => onSpeakerAFirstNameChange(e.target.value)}
              />
            </div>

            <div className={styles.coupleCol}>
              <label className={styles.label} htmlFor="speakerBFirstName">
                Speaker B
              </label>
              <input
                id="speakerBFirstName"
                name="speakerBFirstName"
                type="text"
                value={speakerBFirstName}
                placeholder="First"
                className={styles.input}
                onChange={(e) => onSpeakerBFirstNameChange(e.target.value)}
              />
            </div>
          </div>

          <div className={styles.splitNameRow}>
            <input
              id="speakerALastName"
              name="speakerALastName"
              type="text"
              value={speakerALastName}
              placeholder="Last"
              className={styles.input}
              onChange={(e) => onSpeakerALastNameChange(e.target.value)}
            />
            <input
              id="speakerBLastName"
              name="speakerBLastName"
              type="text"
              value={speakerBLastName}
              placeholder="Last"
              className={styles.input}
              onChange={(e) => onSpeakerBLastNameChange(e.target.value)}
            />
          </div>
        </>
      )}
    </section>
  );
}

SpeakerNameForm.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func,
  embedded: PropTypes.bool,
  imageType: PropTypes.string,
  individualFirstName: PropTypes.string,
  individualLastName: PropTypes.string,
  onIndividualFirstNameChange: PropTypes.func,
  onIndividualLastNameChange: PropTypes.func,
  coupleFirstNames: PropTypes.string,
  coupleLastName: PropTypes.string,
  onCoupleFirstNamesChange: PropTypes.func,
  onCoupleLastNameChange: PropTypes.func,
  speakerAFirstName: PropTypes.string,
  speakerALastName: PropTypes.string,
  speakerBFirstName: PropTypes.string,
  speakerBLastName: PropTypes.string,
  onSpeakerAFirstNameChange: PropTypes.func,
  onSpeakerALastNameChange: PropTypes.func,
  onSpeakerBFirstNameChange: PropTypes.func,
  onSpeakerBLastNameChange: PropTypes.func,
};

SpeakerNameForm.defaultProps = {
  name: "",
  onChange: noop,
  embedded: false,
  imageType: "individual",
  individualFirstName: "",
  individualLastName: "",
  onIndividualFirstNameChange: noop,
  onIndividualLastNameChange: noop,
  coupleFirstNames: "",
  coupleLastName: "",
  onCoupleFirstNamesChange: noop,
  onCoupleLastNameChange: noop,
  speakerAFirstName: "",
  speakerALastName: "",
  speakerBFirstName: "",
  speakerBLastName: "",
  onSpeakerAFirstNameChange: noop,
  onSpeakerALastNameChange: noop,
  onSpeakerBFirstNameChange: noop,
  onSpeakerBLastNameChange: noop,
};

export default SpeakerNameForm;
